<div class="layout-column layout-align-start-start">
  <div class="layout-row layout-align-start-center margin-bottom-10">
    <span class="call">{{ programTypeAliasMap[getFieldValue(call.programType)] || 'F' }}</span>
    <bringoz-icon *ngIf="call.locked && analysis?.routed" iconName="lock" class="gray-102 margin-left-5"></bringoz-icon>
  </div>
  <div class="layout-row layout-align-start-center">
    <bringoz-icon iconName="timer-outline" class="gray-102 margin-right-5"></bringoz-icon>
    <span class="br-body-1"
          *ngIf="!call.destination.serviceTime?.adjusted?.value">{{ call.destination.serviceTime?.initial?.value?.generatedTotalTime | bringozTimeConvert :true }}</span>
    <span class="br-body-1"
          *ngIf="!!call.destination.serviceTime?.adjusted?.value">{{ call.destination.serviceTime?.adjusted?.value?.generatedTotalTime | bringozTimeConvert :true }}</span>
  </div>
  <hr class="main-divider">
  <div class="layout-row layout-align-start-center">
    <div class="layout-row layout-align-start-center">
      <bringoz-icon iconName="time-window-outline" class="gray-102 margin-right-5"></bringoz-icon>
      <span class="br-body-1"
            *ngIf="!call.destination.notBefore?.adjusted?.value">
              {{ {notBefore: call.destination.notBefore?.initial?.value} | bringozTime: 'notBefore' }}
            </span>
      <span class="br-body-1"
            *ngIf="!!call.destination.notBefore?.adjusted?.value">
              {{ {notBefore: call.destination.notBefore?.adjusted?.value} | bringozTime: 'notBefore' }}
            </span>
      <span class="margin-left-5 margin-right-5">-</span>
      <span class="br-body-1"
            *ngIf="!call.destination.notAfter?.adjusted?.value">
              {{ {notBefore: call.destination.notAfter?.initial?.value} | bringozTime: 'notBefore' }}
            </span>
      <span class="br-body-1"
            *ngIf="!!call.destination.notAfter?.adjusted?.value">
              {{ {notBefore: call.destination.notAfter?.adjusted?.value} | bringozTime: 'notBefore' }}
            </span>
    </div>

    <div *ngIf="!!timezoneOffset" class="layout-row layout-align-start-center margin-left-5">
      <bringoz-icon iconName="time-zone"
                    class="gray-102 margin-right-5">
      </bringoz-icon>
      <span class="br-body-1"
            *ngIf="!call.destination.notBefore?.adjusted?.value">
              {{ {notBefore: call.destination.notBefore?.initial?.value} | bringozTime: 'notBefore': undefined: userZoneId }}
            </span>
      <span class="br-body-1"
            *ngIf="!!call.destination.notBefore?.adjusted?.value">
              {{ {notBefore: call.destination.notBefore?.adjusted?.value} | bringozTime: 'notBefore': undefined: userZoneId }}
            </span>
      <span class="margin-left-5 margin-right-5">-</span>
      <span class="br-body-1"
            *ngIf="!call.destination.notAfter?.adjusted?.value">
              {{ {notBefore: call.destination.notAfter?.initial?.value} | bringozTime: 'notBefore': undefined: userZoneId }}
            </span>
      <span class="br-body-1"
            *ngIf="!!call.destination.notAfter?.adjusted?.value">
              {{ {notBefore: call.destination.notAfter?.adjusted?.value} | bringozTime: 'notBefore': undefined: userZoneId }}
            </span>
    </div>

    <!--    <app-bringoz-time-window-tooltip class="margin-left-10"-->
    <!--                                     [notBefore]="!!call.destination.notBefore?.adjusted?.value ? !call.destination.notBefore.adjusted.value: call.destination.notBefore.initial.value"-->
    <!--                                     [notAfter]="!!call.destination.notAfter?.adjusted?.value ? !call.destination.notAfter.adjusted.value: call.destination.notAfter.initial.value"-->
    <!--                                     [timeZoneId]="configZoneId"-->
    <!--                                     [configZoneId]="visitPlan.zoneId">-->

    <!--    </app-bringoz-time-window-tooltip>-->
  </div>
  <hr *ngIf="getFieldValue(call.destination.subtasks)?.length" class="main-divider">
  <div class="layout-column"
       *ngIf="getFieldValue(call.destination.subtasks).length">
    <div *ngFor="let subtask of getFieldValue(call.destination.subtasks)"
         class="layout-row layout-align-start-center">
      <div class="layout-row layout-align-start-center">
        <bringoz-icon iconName="task" class="gray-102"></bringoz-icon>
        <span class="br-body-1 margin-left-5">{{ subtask.title }}</span>
      </div>
      <div class="layout-row layout-align-start-center margin-left-5">
        <bringoz-icon iconName="timer-outline" class="gray-102"></bringoz-icon>
        <span
          class="br-body-1 margin-left-5">{{ subtask.detailedServiceTime.generatedTotalTime| bringozTimeConvert :true }}</span>
      </div>
    </div>
  </div>

  <hr *ngIf="analysis?.agentName" class="main-divider">
  <div class="layout-row layout-align-start-center"
       *ngIf="analysis?.agentName">
    <bringoz-icon iconName="agent" class="gray-102 margin-right-5"></bringoz-icon>
    <span>{{ analysis.agentName }}</span>
  </div>

  <hr *ngIf="analysis?.risks && !!analysis?.risks?.length" class="main-divider">
  <div class="layout-column gap-5"
       *ngIf="analysis?.risks && !!analysis?.risks?.length">
    <div *ngFor="let risk of analysis.risks"
         class="layout-row gap-5">
      <bringoz-icon iconName="error-outline" class="red-102"></bringoz-icon>
      <span class="flex br-body-1 risk-text">
        {{ 'VISIT_PLAN_CALL_RISK.' + risk | translate }}
      </span>
    </div>
  </div>
  <!--  <div class="layout-row layout-align-start-center">-->
  <!--    <bringoz-icon iconName="package-outline" class="gray-102 margin-right-5"></bringoz-icon>-->
  <!--    <span-->
  <!--      *ngIf="!call.destination?.units?.adjusted?.value">{{ call.units.initial.value }}-->
  <!--            </span>-->
  <!--    <span-->
  <!--      *ngIf="!!call.destination?.units?.adjusted?.value">{{ call.units.adjusted.value }}-->
  <!--            </span>-->

  <!--  </div>-->

</div>
